import { IntegrationAuthApp } from '@prisma/client';

import { useGSheetsFeatureFlag } from '@/levity/flows/subscriptions';
import { featureFlagTemplates } from '@/levity/flows/templates';

import { TemplateCard } from './components/template-card.component';
import type { FlowTemplatesProps } from './flow-templates.types';

export const FlowTemplates: React.FC<FlowTemplatesProps> = ({
  onCloneTemplate,
  isCloning,
  showInternalTemplates = false,
}) => {
  const { flagValue: isGSheetsEnabled } = useGSheetsFeatureFlag();

  const flowTemplates = featureFlagTemplates({
    gsheets: isGSheetsEnabled,
    internalTemplates: showInternalTemplates,
  });

  return (
    <div className='flex flex-col gap-2 w-full items-center'>
      <div className='w-full'>
        <h2 className='text-NeutralDarkMedium text-lg not-italic font-semibold leading-6 mb-6'>
          Get started with a template
        </h2>
        <ul className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
          {Object.entries(flowTemplates)
            .filter(([_, flowTemplates]) => Object.values(flowTemplates).length > 0)
            .flatMap(([integration, templates]) =>
              Object.values(templates).map((template) => (
                <li key={template.name} className='col-span-1'>
                  <TemplateCard
                    template={template}
                    integration={integration as IntegrationAuthApp}
                    isCloning={isCloning}
                    onCloneTemplate={onCloneTemplate}
                  />
                </li>
              )),
            )}
        </ul>
      </div>
    </div>
  );
};
